export default "__VITE_ASSET__HaLpnFe4__"